var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDialogEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECE9F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E2DEEC",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14224_49899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0229 21.7019C31.7564 21.4542 31.403 21.3216 31.0393 21.3327C30.6757 21.3438 30.331 21.4978 30.0801 21.7613L21.5965 30.2449L21.3336 34.3679C21.3311 34.4075 21.337 34.4472 21.3511 34.4844C21.3651 34.5215 21.3869 34.5553 21.415 34.5834C21.4431 34.6114 21.4768 34.6332 21.514 34.6473C21.5511 34.6613 21.5908 34.6673 21.6305 34.6648L25.7535 34.4018L34.2371 25.9182C34.5006 25.6673 34.6546 25.3227 34.6657 24.959C34.6768 24.5954 34.5442 24.242 34.2965 23.9755L32.0229 21.7019Z",
    stroke: "#402080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14224_49899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogEditIcon);
export default __webpack_public_path__ + "static/media/dialog-edit-icon.848acf88fdc0a9dc608433f0a5e98f2c.svg";
export { ForwardRef as ReactComponent };